var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.479 6.144a.43.43 0 0 0 0 .641l3.85 3.467a1 1 0 0 0 1.339 0l3.808-3.429a.483.483 0 1 0-.647-.717L8.334 9.263a.5.5 0 0 1-.67 0L4.21 6.144a.546.546 0 0 0-.732 0",
  clipRule: "evenodd"
})));
export default SvgArrowDown;